import * as React from "react";
import {cx} from "emotion";

import "./edition-card-1.scss";

import {to_imgToSmall}     from "@Common/logic/template-options/template-options-image-to-small";
import {to_imgToUltra}     from "@Common/logic/template-options/template-options-image-to-ultra";
import {cs}                from "@Common/react/chain-services";
import {UseState}          from "@Common/react/use-state";
import {ImageGalleryModal} from "@Common/ui-components/image-gallery-modal/image-gallery-modal";
import {parseDateFormat}   from "@Common/utils/date/parse-date-format";
import {chain}             from "@Common/utils/fs";
import {values}            from "@Common/utils/objects";

export const EditionCard1 = (
    {
        edition, selected, disabled, getStyleTemplate, onDeselect,
        onSelect, className,
        productName,
    }
) => cs(
    ["hover", (_, next) => UseState({next})],
    ["hoverThumbnail", (_, next) => UseState({next})],
    ["imageGalleryModal", (_, next) => ImageGalleryModal({next})],

    ({hover, hoverThumbnail, imageGalleryModal}) => (
        <div {...{
            className: cx("edition-1-5wk", className, {
                selected,
                disabled,
                hovered: hover.value && !hoverThumbnail.value
            }),

            onMouseEnter: () => hover.onChange(true),
            onMouseLeave: () => hover.onChange(false),
            onClick: disabled ? undefined : (() => {

                if (selected) {
                    onDeselect?.();
                } else {
                    onSelect();
                }
            }),

            "xd-qa-type": "card",
            "xd-qa-name": "Edition " + edition.name,
        }}>
            <div className="line1">

                <div className="text">
                    <div {...{
                        className: "label",

                        "xd-qa-type": "label",
                        "xd-qa-name": "Edition Name",
                    }}>
                        {edition.name}
                    </div>
                    <div {...{
                        className: "product-name",

                        "xd-qa-type": "label",
                        "xd-qa-name": "Product Name",
                    }}>
                        {productName}
                    </div>

                    <div {...{
                        className: "deadline",
                    }}>
                        <div {...{
                            className: "label",
                        }}>
                            Enrollment Deadline:
                        </div>

                        <div {...{
                            className: "value",
                            "xd-qa-type": "label",
                            "xd-qa-name": "Enrollment Deadline",
                        }}>
                            {reformatDate(edition.enrollmentDeadline)}
                        </div>
                    </div>

                    <div {...{
                        className: "deadline",
                    }}>
                        <div {...{
                            className: "label",
                        }}>
                            Final Day to Edit:
                        </div>

                        <div {...{
                            className: "value",
                            "xd-qa-type": "label",
                            "xd-qa-name": "Final Day to Edit",
                        }}>
                            {reformatDate(edition.orderReviewDeadline)}
                        </div>
                    </div>

                </div>

                {cs(
                    ["template", (_, next) => next(getStyleTemplate(edition.templateId))],
                    ["imgs", ({template}, next) => next(values(template?.images ?? {})?.map(({url}) => ({
                        thumbnail: to_imgToSmall(url),
                        enlarged: to_imgToUltra(url),
                    })))],

                    ({imgs}) => (
                        <div {...{
                            className: cx("thumbnail", {hovered: hoverThumbnail.value}),
                            onMouseEnter: () => hoverThumbnail.onChange(true),
                            onMouseLeave: () => hoverThumbnail.onChange(false),
                        }}>
                            <img {...{
                                src: chain(
                                    imgs?.[0],
                                    (_) => _?.thumbnail ?? _?.enlarged,
                                ),

                                onClick: (e) => {
                                    e.stopPropagation();
                                    if (imgs?.length) {
                                        imageGalleryModal.show({imgs});
                                    }
                                },

                                "xd-qa-type": "image",
                                "xd-qa-name": "Edition Image",
                            }}/>
                        </div>
                    )
                )}
            </div>

            {edition.description && (
                <div {...{
                    className: "description",
                }}>
                    <div className="label">
                        Description
                    </div>

                    <div {...{
                        className: "value",
                        "xd-qa-type": "label",
                        "xd-qa-name": "Edition Description",
                    }}>
                        {edition.description}
                    </div>
                </div>
            )}

            {selected && (
                <div className="check" xd-qa-type="checkbox" xd-qa-name="Edition Selected">
                    <i className="fa fa-check-circle"/>
                </div>
            )}
            {/*<div className="checkbox">*/}
            {/*    {Checkbox({*/}
            {/*        checked: selected,*/}
            {/*        rounded: true,*/}
            {/*        xdQaName: "Edition Selected",*/}
            {/*    })}*/}
            {/*</div>*/}
        </div>
    ),
);

const reformatDate = (str) => formatDate(parseDate(str));
const formatDate = (date) => parseDateFormat("mm/dd/yyyy").formatDate(date);
const parseDate = (str):any => parseDateFormat("yyyy-mm-dd").parseDate(str);
